import { TextBox, TextBoxProps } from '@idexx-laboratories/spot-react';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import './TextBoxInCell.scss';

const TextBoxInCell = forwardRef<HTMLInputElement, TextBoxProps>(
  ({ className, ...rest }, ref): React.JSX.Element => (
    <TextBox className={classNames(className, 'in-cell')} {...rest} ref={ref} />
  ),
);

export default TextBoxInCell;
